module.exports = __webpack_public_path__ + "img/113.cb40185d.jpg";